webpackJsonp([1],{

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Login = __webpack_require__(566);

var _Login2 = _interopRequireDefault(_Login);

var _ = __webpack_require__(561);

var _2 = _interopRequireDefault(_);

var _Home = __webpack_require__(565);

var _Home2 = _interopRequireDefault(_Home);

var _Music = __webpack_require__(567);

var _Music2 = _interopRequireDefault(_Music);

var _User = __webpack_require__(570);

var _User2 = _interopRequireDefault(_User);

var _Category = __webpack_require__(564);

var _Category2 = _interopRequireDefault(_Category);

var _Singer = __webpack_require__(569);

var _Singer2 = _interopRequireDefault(_Singer);

var _Password = __webpack_require__(568);

var _Password2 = _interopRequireDefault(_Password);

var _Album = __webpack_require__(562);

var _Album2 = _interopRequireDefault(_Album);

var _AlbumMusic = __webpack_require__(563);

var _AlbumMusic2 = _interopRequireDefault(_AlbumMusic);

var _Version = __webpack_require__(571);

var _Version2 = _interopRequireDefault(_Version);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = [{
    path: '/login',
    component: _Login2.default,
    name: '',
    hidden: true
}, {
    path: '/404',
    component: _2.default,
    name: '',
    hidden: true
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-music',
    leaf: true,
    children: [{ path: '/music', component: _Music2.default, name: '歌曲' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-user',
    leaf: true,
    children: [{ path: '/user', component: _User2.default, name: '用户' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-bars',
    leaf: true,
    children: [{ path: '/category', component: _Category2.default, name: '分类' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-id-card-o',
    leaf: true,
    children: [{ path: '/singer', component: _Singer2.default, name: '歌手' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-address-card',
    leaf: true,
    children: [{ path: '/album', component: _Album2.default, name: '歌单' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    hidden: true,
    iconCls: 'fa fa-address-card',
    leaf: true,
    children: [{ path: '/albumMusic', component: _AlbumMusic2.default, name: '歌单歌曲' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-arrow-circle-down',
    leaf: true,
    children: [{ path: '/version', component: _Version2.default, name: '版本' }]
}, {
    path: '/',
    hidden: true,
    name: '',
    component: _Home2.default,
    leaf: true,
    children: [{ path: '/password', component: _Password2.default, name: '修改密码' }]
}, {
    path: '*',
    hidden: true,
    redirect: { path: '/404' }
}];

exports.default = routes;

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(19);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(150);

var _vuex2 = _interopRequireDefault(_vuex);

var _actions = __webpack_require__(284);

var actions = _interopRequireWildcard(_actions);

var _getters = __webpack_require__(285);

var getters = _interopRequireWildcard(_getters);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var state = {
    count: 10
};

var mutations = {
    INCREMENT: function INCREMENT(state) {
        state.count++;
    },
    DECREMENT: function DECREMENT(state) {
        state.count--;
    }
};

exports.default = new _vuex2.default.Store({
    actions: actions,
    getters: getters,
    state: state,
    mutations: mutations
});

/***/ }),

/***/ 227:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 228:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 229:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(548)

var Component = __webpack_require__(24)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(574),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	name: 'app',
	components: {}
};

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__(40);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(71);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(37);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(36);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _util = __webpack_require__(47);

var _util2 = _interopRequireDefault(_util);

var _api = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			filters: {
				type: this.$route.query.userId ? 'userId' : 'name',
				name: this.$route.query.userId || ''
			},
			placeholder: this.$route.query.userId ? '用户ID' : '歌单名称',
			recordList: [],
			pageTotal: 0,
			currentPage: 1,
			pageSize: 15,
			pageNo: 1,
			listLoading: false,
			sels: [],

			editFormVisible: false,
			editLoading: false,
			editFormRules: {
				name: [{ required: true, message: '请输入歌手名', trigger: 'blur' }],
				userId: [{ required: true, message: '请选择用户', trigger: 'blur' }]
			},

			editForm: {
				id: 0,
				name: '',
				userId: '',
				username: ''
			},

			addFormVisible: false,
			addLoading: false,
			addFormRules: {
				name: [{ required: true, message: '请输入歌手名', trigger: 'blur' }],
				userId: [{ required: true, message: '请选择用户', trigger: 'blur' }]
			},

			addForm: {
				name: '',
				userId: '',
				username: ''
			}

		};
	},

	methods: {
		handleCurrentChange: function handleCurrentChange(val) {
			this.currentPage = val;
			this.fetch();
		},

		gotoAlbumMusic: function gotoAlbumMusic(album) {
			this.$router.push({
				path: '/albumMusic',
				query: {
					albumId: album._id,
					userId: album.userId,
					title: album.name,
					username: album.username
				}
			});
		},
		fetch: function fetch() {
			var _this = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var para, res;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								para = {
									type: _this.filters.type,
									name: _this.filters.name,
									currentPage: _this.currentPage,
									pageSize: _this.pageSize
								};

								_this.listLoading = true;
								_context.next = 4;
								return (0, _api.getAlbumListPage)(para);

							case 4:
								res = _context.sent;

								_this.listLoading = false;

								if (!(res.data.status !== 200)) {
									_context.next = 9;
									break;
								}

								_this.$message({
									message: res.data.message,
									type: 'warning'
								});
								return _context.abrupt('return');

							case 9:
								_this.currentPage = res.data.data.currentPage;
								_this.pageSize = res.data.data.pageSize;
								_this.pageNo = res.data.data.pageNo;
								_this.pageTotal = res.data.data.pageTotal;
								_this.recordList = res.data.data.recordList;

							case 14:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		searchUser: function searchUser(name, callback) {
			var _this2 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
				var res;
				return _regenerator2.default.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								_context2.next = 2;
								return (0, _api.getUserList)({ name: name });

							case 2:
								res = _context2.sent;

								callback(res.data.data.recordList.map(function (item) {
									return (0, _extends3.default)({}, item, { value: item.name });
								}));

							case 4:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this2);
			}))();
		},

		handleEdit: function handleEdit(index, row) {
			this.editFormVisible = true;
			this.editForm = (0, _assign2.default)({}, row);
		},

		handleAdd: function handleAdd() {
			this.addFormVisible = true;
			this.addForm = {
				name: '',
				userId: this.filters.type === 'userId' && this.filters.name ? this.$route.query.userId : '',
				username: this.filters.type === 'userId' && this.filters.name ? this.$route.query.username : ''
			};
		},

		editSubmit: function editSubmit() {
			var _this3 = this;

			this.$refs.editForm.validate(function () {
				var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(valid) {
					var para, res;
					return _regenerator2.default.wrap(function _callee3$(_context3) {
						while (1) {
							switch (_context3.prev = _context3.next) {
								case 0:
									if (!valid) {
										_context3.next = 14;
										break;
									}

									_this3.editLoading = true;
									para = (0, _assign2.default)({}, _this3.editForm);
									_context3.next = 5;
									return (0, _api.editAlbum)(para);

								case 5:
									res = _context3.sent;

									_this3.editLoading = false;

									if (!(res.data.status !== 200)) {
										_context3.next = 10;
										break;
									}

									_this3.$message({
										message: res.data.message,
										type: 'warning'
									});
									return _context3.abrupt('return');

								case 10:
									_this3.$message({
										message: '提交成功',
										type: 'success'
									});
									_this3.$refs['editForm'].resetFields();
									_this3.editFormVisible = false;
									_this3.fetch();

								case 14:
								case 'end':
									return _context3.stop();
							}
						}
					}, _callee3, _this3);
				}));

				return function (_x) {
					return _ref.apply(this, arguments);
				};
			}());
		},

		addSubmit: function addSubmit() {
			var _this4 = this;

			this.$refs.addForm.validate(function () {
				var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(valid) {
					var para, res;
					return _regenerator2.default.wrap(function _callee4$(_context4) {
						while (1) {
							switch (_context4.prev = _context4.next) {
								case 0:
									if (!valid) {
										_context4.next = 14;
										break;
									}

									_this4.addLoading = true;
									para = (0, _assign2.default)({}, _this4.addForm);
									_context4.next = 5;
									return (0, _api.addAlbum)(para);

								case 5:
									res = _context4.sent;

									_this4.addLoading = false;

									if (!(res.data.status !== 200)) {
										_context4.next = 10;
										break;
									}

									_this4.$message({
										message: res.data.message,
										type: 'warning'
									});
									return _context4.abrupt('return');

								case 10:
									_this4.$message({
										message: '提交成功',
										type: 'success'
									});
									_this4.$refs['addForm'].resetFields();
									_this4.addFormVisible = false;
									_this4.fetch();

								case 14:
								case 'end':
									return _context4.stop();
							}
						}
					}, _callee4, _this4);
				}));

				return function (_x2) {
					return _ref2.apply(this, arguments);
				};
			}());
		},
		handleSelect: function handleSelect(item) {
			if (this.addFormVisible) {
				this.addForm.userId = item._id;
			} else if (this.editFormVisible) {
				this.editForm.userId = item._id;
			}
		},

		handleDel: function handleDel(index, row) {
			var _this5 = this;

			this.$confirm('确认删除该记录吗?', '提示', {
				type: 'warning'
			}).then((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
				var para, res;
				return _regenerator2.default.wrap(function _callee5$(_context5) {
					while (1) {
						switch (_context5.prev = _context5.next) {
							case 0:
								_this5.listLoading = true;
								para = { id: row._id };
								_context5.next = 4;
								return (0, _api.removeAlbum)(para);

							case 4:
								res = _context5.sent;

								_this5.listLoading = false;

								if (!(res.data.status !== 200)) {
									_context5.next = 9;
									break;
								}

								_this5.$message({
									message: res.data.message,
									type: 'warning'
								});
								return _context5.abrupt('return');

							case 9:
								_this5.$message({
									message: '删除成功',
									type: 'success'
								});
								_this5.fetch();

							case 11:
							case 'end':
								return _context5.stop();
						}
					}
				}, _callee5, _this5);
			}))).catch(function () {});
		},
		handleSearchTypeChange: function handleSearchTypeChange(value) {
			if (value === 'name') {
				this.placeholder = '歌单名称';
				this.filters.name = '';
				this.fetch();
			} else {
				this.placeholder = '用户ID';
				this.filters.name = '';
			}
		},

		selsChange: function selsChange(sels) {
			this.sels = sels;
		},

		batchRemove: function batchRemove() {
			var _this6 = this;

			var ids = this.sels.map(function (item) {
				return item._id;
			}).toString();
			this.$confirm('确认删除选中记录吗？', '提示', {
				type: 'warning'
			}).then((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
				var para, res;
				return _regenerator2.default.wrap(function _callee6$(_context6) {
					while (1) {
						switch (_context6.prev = _context6.next) {
							case 0:
								_this6.listLoading = true;
								para = { ids: ids };
								_context6.next = 4;
								return (0, _api.batchRemoveAlbum)(para);

							case 4:
								res = _context6.sent;

								_this6.listLoading = false;

								if (!(res.data.status !== 200)) {
									_context6.next = 9;
									break;
								}

								_this6.$message({
									message: res.data.message,
									type: 'warning'
								});
								return _context6.abrupt('return');

							case 9:
								_this6.$message({
									message: '删除成功',
									type: 'success'
								});
								_this6.fetch();

							case 11:
							case 'end':
								return _context6.stop();
						}
					}
				}, _callee6, _this6);
			}))).catch(function () {});
		}
	},
	mounted: function mounted() {
		this.fetch();
	}
};

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__(40);

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = __webpack_require__(37);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = __webpack_require__(71);

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = __webpack_require__(36);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _util = __webpack_require__(47);

var _util2 = _interopRequireDefault(_util);

var _api = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			filters: {
				name: ''
			},
			recordList: [],
			categorys: [],
			pageTotal: 0,
			currentPage: 1,
			pageSize: 15,
			pageNo: 1,
			listLoading: false,
			sels: [],

			editFormVisible: false,
			editLoading: false,
			editFormRules: {
				name: [{ required: true, message: '请输入歌曲名', trigger: 'blur' }]
			},

			editForm: {
				id: 0,
				albumId: this.$route.query.albumId,
				userId: this.$route.query.userId,
				musicId: '',
				singerName: '',
				url: '',
				fileName: '',
				fileSize: '0',
				name: '',
				hash: '',
				priority: '999'
			},

			addFormVisible: false,
			addLoading: false,
			addFormRules: {
				name: [{ required: true, message: '请输入歌曲名', trigger: 'blur' }]
			},

			addForm: {
				albumId: this.$route.query.albumId,
				userId: this.$route.query.userId,
				musicId: '',
				singerName: '',
				url: '',
				fileName: '',
				fileSize: '0',
				name: '',
				hash: '',
				priority: '999'
			}
		};
	},

	methods: {
		handleCurrentChange: function handleCurrentChange(val) {
			this.currentPage = val;
			this.fetch();
		},
		back: function back() {
			this.$router.back();
		},
		searchMusic: function searchMusic(name, callback) {
			var _this = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var res;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return (0, _api.getMusicList)({ name: name });

							case 2:
								res = _context.sent;

								callback(res.data.data.recordList.map(function (item) {
									return (0, _extends3.default)({}, item, { value: item.name });
								}));

							case 4:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},

		formatCategory: function formatCategory(row, column) {
			var arr = this.categorys.filter(function (item) {
				return item._id === row.categoryId;
			});
			if (arr && arr.length > 0) {
				return arr[0].name;
			} else {
				return '';
			}
		},
		fetch: function fetch() {
			var _this2 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
				var para, res;
				return _regenerator2.default.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								para = {
									albumId: _this2.$route.query.albumId,
									name: _this2.filters.name,
									currentPage: _this2.currentPage,
									pageSize: _this2.pageSize
								};

								_this2.listLoading = true;
								_context2.next = 4;
								return (0, _api.getAlbumMusicListPage)(para);

							case 4:
								res = _context2.sent;

								_this2.listLoading = false;

								if (!(res.data.status !== 200)) {
									_context2.next = 9;
									break;
								}

								_this2.$message({
									message: res.data.message,
									type: 'warning'
								});
								return _context2.abrupt('return');

							case 9:
								_this2.currentPage = res.data.data.currentPage;
								_this2.pageSize = res.data.data.pageSize;
								_this2.pageNo = res.data.data.pageNo;
								_this2.pageTotal = res.data.data.pageTotal;
								_this2.recordList = res.data.data.recordList;

							case 14:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this2);
			}))();
		},
		getCateList: function getCateList() {
			var _this3 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
				var res;
				return _regenerator2.default.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								_context3.next = 2;
								return (0, _api.getCategoryList)();

							case 2:
								res = _context3.sent;

								_this3.categorys = res.data.data.recordList;

							case 4:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, _this3);
			}))();
		},

		handleEdit: function handleEdit(index, row) {
			this.editFormVisible = true;
			this.editForm = (0, _assign2.default)({}, row);
		},

		handleAdd: function handleAdd() {
			this.addFormVisible = true;
			this.addForm = {
				albumId: this.$route.query.albumId,
				userId: this.$route.query.userId,
				musicId: '',
				singerName: '',
				url: '',
				fileName: '',
				fileSize: '0',
				name: '',
				hash: '',
				priority: '999'
			};
		},

		editSubmit: function editSubmit() {
			var _this4 = this;

			this.$refs.editForm.validate(function () {
				var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(valid) {
					var para, res;
					return _regenerator2.default.wrap(function _callee4$(_context4) {
						while (1) {
							switch (_context4.prev = _context4.next) {
								case 0:
									if (!valid) {
										_context4.next = 14;
										break;
									}

									_this4.editLoading = true;
									para = (0, _assign2.default)({}, _this4.editForm);
									_context4.next = 5;
									return (0, _api.editAlbumMusic)(para);

								case 5:
									res = _context4.sent;

									_this4.editLoading = false;

									if (!(res.data.status !== 200)) {
										_context4.next = 10;
										break;
									}

									_this4.$message({
										message: res.data.message,
										type: 'warning'
									});
									return _context4.abrupt('return');

								case 10:
									_this4.$message({
										message: '提交成功',
										type: 'success'
									});
									_this4.$refs['editForm'].resetFields();
									_this4.editFormVisible = false;
									_this4.fetch();

								case 14:
								case 'end':
									return _context4.stop();
							}
						}
					}, _callee4, _this4);
				}));

				return function (_x) {
					return _ref.apply(this, arguments);
				};
			}());
		},

		addSubmit: function addSubmit() {
			var _this5 = this;

			this.$refs.addForm.validate(function () {
				var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(valid) {
					var para, res;
					return _regenerator2.default.wrap(function _callee5$(_context5) {
						while (1) {
							switch (_context5.prev = _context5.next) {
								case 0:
									if (!valid) {
										_context5.next = 14;
										break;
									}

									_this5.addLoading = true;
									para = (0, _assign2.default)({}, _this5.addForm);
									_context5.next = 5;
									return (0, _api.addAlbumMusic)(para);

								case 5:
									res = _context5.sent;

									_this5.addLoading = false;

									if (!(res.data.status !== 200)) {
										_context5.next = 10;
										break;
									}

									_this5.$message({
										message: res.data.message,
										type: 'warning'
									});
									return _context5.abrupt('return');

								case 10:
									_this5.$message({
										message: '提交成功',
										type: 'success'
									});
									_this5.$refs['addForm'].resetFields();
									_this5.addFormVisible = false;
									_this5.fetch();

								case 14:
								case 'end':
									return _context5.stop();
							}
						}
					}, _callee5, _this5);
				}));

				return function (_x2) {
					return _ref2.apply(this, arguments);
				};
			}());
		},
		handleSelect: function handleSelect(item) {
			if (this.addFormVisible) {
				this.addForm.musicId = item._id;
				this.addForm.singerId = item.singerId;
				this.addForm.categoryId = item.categoryId;
				this.addForm.singerName = item.singerName;
				this.addForm.url = item.url;
				this.addForm.fileName = item.fileName;
				this.addForm.fileSize = item.fileSize;
				this.addForm.name = item.name;
				this.addForm.hash = item.hash;
			} else if (this.editFormVisible) {
				this.editForm.musicId = item._id;
				this.editForm.singerId = item.singerId;
				this.editForm.categoryId = item.categoryId;
				this.editForm.singerName = item.singerName;
				this.editForm.url = item.url;
				this.editForm.fileName = item.fileName;
				this.editForm.fileSize = item.fileSize;
				this.editForm.name = item.name;
				this.editForm.hash = item.hash;
			}
		},

		handleDel: function handleDel(index, row) {
			var _this6 = this;

			this.$confirm('确认删除该记录吗?', '提示', {
				type: 'warning'
			}).then((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
				var para, res;
				return _regenerator2.default.wrap(function _callee6$(_context6) {
					while (1) {
						switch (_context6.prev = _context6.next) {
							case 0:
								_this6.listLoading = true;
								para = { id: row._id };
								_context6.next = 4;
								return (0, _api.removeAlbumMusic)(para);

							case 4:
								res = _context6.sent;

								_this6.listLoading = false;

								if (!(res.data.status !== 200)) {
									_context6.next = 9;
									break;
								}

								_this6.$message({
									message: res.data.message,
									type: 'warning'
								});
								return _context6.abrupt('return');

							case 9:
								_this6.$message({
									message: '删除成功',
									type: 'success'
								});
								_this6.fetch();

							case 11:
							case 'end':
								return _context6.stop();
						}
					}
				}, _callee6, _this6);
			}))).catch(function () {});
		},
		selsChange: function selsChange(sels) {
			this.sels = sels;
		},

		batchRemove: function batchRemove() {
			var _this7 = this;

			var ids = this.sels.map(function (item) {
				return item._id;
			}).toString();
			this.$confirm('确认删除选中记录吗？', '提示', {
				type: 'warning'
			}).then((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7() {
				var para, res;
				return _regenerator2.default.wrap(function _callee7$(_context7) {
					while (1) {
						switch (_context7.prev = _context7.next) {
							case 0:
								_this7.listLoading = true;
								para = { ids: ids };
								_context7.next = 4;
								return (0, _api.batchRemoveAlbumMusic)(para);

							case 4:
								res = _context7.sent;

								_this7.listLoading = false;

								if (!(res.data.status !== 200)) {
									_context7.next = 9;
									break;
								}

								_this7.$message({
									message: res.data.message,
									type: 'warning'
								});
								return _context7.abrupt('return');

							case 9:
								_this7.$message({
									message: '删除成功',
									type: 'success'
								});
								_this7.fetch();

							case 11:
							case 'end':
								return _context7.stop();
						}
					}
				}, _callee7, _this7);
			}))).catch(function () {});
		}
	},
	mounted: function mounted() {
		var _this8 = this;

		return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8() {
			return _regenerator2.default.wrap(function _callee8$(_context8) {
				while (1) {
					switch (_context8.prev = _context8.next) {
						case 0:
							_context8.next = 2;
							return _this8.getCateList();

						case 2:
							_this8.fetch();

						case 3:
						case 'end':
							return _context8.stop();
					}
				}
			}, _callee8, _this8);
		}))();
	}
};

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__(40);

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = __webpack_require__(37);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(36);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _util = __webpack_require__(47);

var _util2 = _interopRequireDefault(_util);

var _api = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			filters: {
				name: ''
			},
			recordList: [],
			pageTotal: 0,
			currentPage: 1,
			pageSize: 15,
			pageNo: 1,
			listLoading: false,
			sels: [],

			editFormVisible: false,
			editLoading: false,
			editFormRules: {
				name: [{ required: true, message: '请输入分类名称', trigger: 'blur' }]
			},

			editForm: {
				id: 0,
				name: ''
			},

			addFormVisible: false,
			addLoading: false,
			addFormRules: {
				name: [{ required: true, message: '请输入分类名称', trigger: 'blur' }]
			},

			addForm: {
				name: ''
			}

		};
	},

	methods: {
		handleCurrentChange: function handleCurrentChange(val) {
			this.currentPage = val;
			this.fetch();
		},
		fetch: function fetch() {
			var _this = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var para, res;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								para = {
									name: _this.filters.name,
									currentPage: _this.currentPage,
									pageSize: _this.pageSize
								};

								_this.listLoading = true;
								_context.next = 4;
								return (0, _api.getCategoryListPage)(para);

							case 4:
								res = _context.sent;

								_this.listLoading = false;

								if (!(res.data.status !== 200)) {
									_context.next = 9;
									break;
								}

								_this.$message({
									message: res.data.message,
									type: 'warning'
								});
								return _context.abrupt('return');

							case 9:
								_this.currentPage = res.data.data.currentPage;
								_this.pageSize = res.data.data.pageSize;
								_this.pageNo = res.data.data.pageNo;
								_this.pageTotal = res.data.data.pageTotal;
								_this.recordList = res.data.data.recordList;

							case 14:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},

		handleEdit: function handleEdit(index, row) {
			this.editFormVisible = true;
			this.editForm = (0, _assign2.default)({}, row);
		},

		handleAdd: function handleAdd() {
			this.addFormVisible = true;
			this.addForm = {
				name: ''
			};
		},

		editSubmit: function editSubmit() {
			var _this2 = this;

			this.$refs.editForm.validate(function () {
				var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(valid) {
					var para, res;
					return _regenerator2.default.wrap(function _callee2$(_context2) {
						while (1) {
							switch (_context2.prev = _context2.next) {
								case 0:
									if (!valid) {
										_context2.next = 14;
										break;
									}

									_this2.editLoading = true;
									para = (0, _assign2.default)({}, _this2.editForm);
									_context2.next = 5;
									return (0, _api.editCategory)(para);

								case 5:
									res = _context2.sent;

									_this2.editLoading = false;

									if (!(res.data.status !== 200)) {
										_context2.next = 10;
										break;
									}

									_this2.$message({
										message: res.data.message,
										type: 'warning'
									});
									return _context2.abrupt('return');

								case 10:
									_this2.$message({
										message: '提交成功',
										type: 'success'
									});
									_this2.$refs['editForm'].resetFields();
									_this2.editFormVisible = false;
									_this2.fetch();

								case 14:
								case 'end':
									return _context2.stop();
							}
						}
					}, _callee2, _this2);
				}));

				return function (_x) {
					return _ref.apply(this, arguments);
				};
			}());
		},

		addSubmit: function addSubmit() {
			var _this3 = this;

			this.$refs.addForm.validate(function () {
				var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(valid) {
					var para, res;
					return _regenerator2.default.wrap(function _callee3$(_context3) {
						while (1) {
							switch (_context3.prev = _context3.next) {
								case 0:
									if (!valid) {
										_context3.next = 14;
										break;
									}

									_this3.addLoading = true;
									para = (0, _assign2.default)({}, _this3.addForm);
									_context3.next = 5;
									return (0, _api.addCategory)(para);

								case 5:
									res = _context3.sent;

									_this3.addLoading = false;

									if (!(res.data.status !== 200)) {
										_context3.next = 10;
										break;
									}

									_this3.$message({
										message: res.data.message,
										type: 'warning'
									});
									return _context3.abrupt('return');

								case 10:
									_this3.$message({
										message: '提交成功',
										type: 'success'
									});
									_this3.$refs['addForm'].resetFields();
									_this3.addFormVisible = false;
									_this3.fetch();

								case 14:
								case 'end':
									return _context3.stop();
							}
						}
					}, _callee3, _this3);
				}));

				return function (_x2) {
					return _ref2.apply(this, arguments);
				};
			}());
		},

		handleDel: function handleDel(index, row) {
			var _this4 = this;

			this.$confirm('确认删除该记录吗?', '提示', {
				type: 'warning'
			}).then((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
				var para, res;
				return _regenerator2.default.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								_this4.listLoading = true;
								para = { id: row._id };
								_context4.next = 4;
								return (0, _api.removeCategory)(para);

							case 4:
								res = _context4.sent;

								_this4.listLoading = false;

								if (!(res.data.status !== 200)) {
									_context4.next = 9;
									break;
								}

								_this4.$message({
									message: res.data.message,
									type: 'warning'
								});
								return _context4.abrupt('return');

							case 9:
								_this4.$message({
									message: '删除成功',
									type: 'success'
								});
								_this4.fetch();

							case 11:
							case 'end':
								return _context4.stop();
						}
					}
				}, _callee4, _this4);
			}))).catch(function () {});
		},
		selsChange: function selsChange(sels) {
			this.sels = sels;
		},

		batchRemove: function batchRemove() {
			var _this5 = this;

			var ids = this.sels.map(function (item) {
				return item._id;
			}).toString();
			this.$confirm('确认删除选中记录吗？', '提示', {
				type: 'warning'
			}).then((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
				var para, res;
				return _regenerator2.default.wrap(function _callee5$(_context5) {
					while (1) {
						switch (_context5.prev = _context5.next) {
							case 0:
								_this5.listLoading = true;
								para = { ids: ids };
								_context5.next = 4;
								return (0, _api.batchRemoveCategory)(para);

							case 4:
								res = _context5.sent;

								_this5.listLoading = false;

								if (!(res.data.status !== 200)) {
									_context5.next = 9;
									break;
								}

								_this5.$message({
									message: res.data.message,
									type: 'warning'
								});
								return _context5.abrupt('return');

							case 9:
								_this5.$message({
									message: '删除成功',
									type: 'success'
								});
								_this5.fetch();

							case 11:
							case 'end':
								return _context5.stop();
						}
					}
				}, _callee5, _this5);
			}))).catch(function () {});
		}
	},
	mounted: function mounted() {
		this.fetch();
	}
};

/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	data: function data() {
		return {
			sysName: 'CLASSIC MUSIC',
			collapsed: false,
			sysUserName: '',
			form: {
				name: '',
				region: '',
				date1: '',
				date2: '',
				delivery: false,
				type: [],
				resource: '',
				desc: ''
			}
		};
	},

	methods: {
		onSubmit: function onSubmit() {
			console.log('submit!');
		},
		handleopen: function handleopen() {},
		handleclose: function handleclose() {},

		handleselect: function handleselect(a, b) {},

		logout: function logout() {
			var _this = this;
			this.$confirm('确认退出吗?', '提示', {}).then(function () {
				sessionStorage.removeItem('user');
				sessionStorage.removeItem('token');
				_this.$router.push('/login');
			}).catch(function () {});
		},

		changePassword: function changePassword() {
			this.$router.push('/password');
		},

		collapse: function collapse() {
			this.collapsed = !this.collapsed;
		},
		showMenu: function showMenu(i, status) {
			this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-' + i)[0].style.display = status ? 'block' : 'none';
		}
	},
	mounted: function mounted() {
		var user = sessionStorage.getItem('user');
		if (user) {
			user = JSON.parse(user);
			this.sysUserName = user.name || '';
		}
	}
};

/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(37);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = __webpack_require__(287);

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = __webpack_require__(36);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _api = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      logining: false,
      ruleForm2: {
        account: '',
        checkPass: ''
      },
      rules2: {
        account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        checkPass: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      checked: false
    };
  },

  methods: {
    handleReset2: function handleReset2() {
      this.$refs.ruleForm2.resetFields();
    },
    handleSubmit2: function handleSubmit2(ev) {
      var _this2 = this;

      var _this = this;
      this.$refs.ruleForm2.validate(function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(valid) {
          var loginParams, data, message, status, user, info;
          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!valid) {
                    _context.next = 26;
                    break;
                  }

                  _this2.logining = true;
                  loginParams = { mobile: _this2.ruleForm2.account, password: _this2.ruleForm2.checkPass };
                  _context.prev = 3;
                  _context.next = 6;
                  return (0, _api.requestLogin)(loginParams);

                case 6:
                  data = _context.sent;

                  _this2.logining = false;
                  message = data.message, status = data.status, user = data.data;

                  if (!(status !== 200)) {
                    _context.next = 12;
                    break;
                  }

                  _this2.$message({
                    message: message,
                    type: 'error'
                  });
                  return _context.abrupt('return', false);

                case 12:
                  sessionStorage.setItem('user', (0, _stringify2.default)(user));
                  sessionStorage.setItem('token', user.token);
                  _context.next = 16;
                  return (0, _api.getUserInfo)();

                case 16:
                  info = _context.sent;

                  _this2.$router.push({ path: '/music' });
                  _context.next = 24;
                  break;

                case 20:
                  _context.prev = 20;
                  _context.t0 = _context['catch'](3);

                  _this2.logining = false;

                  console.log(_context.t0);

                case 24:
                  _context.next = 28;
                  break;

                case 26:
                  console.log('error submit!!');
                  return _context.abrupt('return', false);

                case 28:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this2, [[3, 20]]);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};

/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__(40);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(71);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(37);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(36);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _util = __webpack_require__(47);

var _util2 = _interopRequireDefault(_util);

var _api = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		var token = sessionStorage.getItem('token');
		return {
			headers: { Authorization: 'Bearer ' + token },
			filters: {
				name: ''
			},
			recordList: [],
			fileList: [],
			categorys: [],
			pageTotal: 0,
			currentPage: 1,
			pageSize: 15,
			pageNo: 1,
			listLoading: false,
			sels: [],

			editFormVisible: false,
			editLoading: false,
			editFormRules: {
				name: [{ required: true, message: '请输入歌曲名', trigger: 'blur' }],
				categoryId: [{ required: true, message: '请选择分类', trigger: 'blur' }],
				singerId: [{ required: true, message: '请填写歌手', trigger: 'blur' }],
				url: [{ required: true, message: '请上传文件', trigger: 'blur' }]
			},

			editForm: {
				id: 0,
				name: '',
				categoryId: '',
				url: '',
				fileName: '',
				hash: '',
				fileSize: '',
				singerId: '',
				singerName: ''
			},

			addFormVisible: false,
			addLoading: false,
			addFormRules: {
				name: [{ required: true, message: '请输入歌曲名', trigger: 'blur' }],
				categoryId: [{ required: true, message: '请选择分类', trigger: 'blur' }],
				singerId: [{ required: true, message: '请填写歌手', trigger: 'blur' }],
				url: [{ required: true, message: '请上传文件', trigger: 'blur' }]
			},

			addForm: {
				name: '',
				categoryId: '',
				url: '',
				fileName: '',
				hash: '',
				fileSize: '',
				singerId: '',
				singerName: ''
			},
			uploadUrl: _api.uploadUrl,
			addSingerLoading: false
		};
	},

	methods: {
		handleCurrentChange: function handleCurrentChange(val) {
			this.currentPage = val;
			this.fetch();
		},

		formatCategory: function formatCategory(row, column) {
			var arr = this.categorys.filter(function (item) {
				return item._id === row.categoryId;
			});
			if (arr && arr.length > 0) {
				return arr[0].name;
			} else {
				return '';
			}
		},
		fetch: function fetch() {
			var _this = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var para, res;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								para = {
									name: _this.filters.name,
									currentPage: _this.currentPage,
									pageSize: _this.pageSize
								};

								_this.listLoading = true;
								_context.next = 4;
								return (0, _api.getMusicListPage)(para);

							case 4:
								res = _context.sent;

								_this.listLoading = false;

								if (!(res.data.status !== 200)) {
									_context.next = 9;
									break;
								}

								_this.$message({
									message: res.data.message,
									type: 'warning'
								});
								return _context.abrupt('return');

							case 9:
								_this.currentPage = res.data.data.currentPage;
								_this.pageSize = res.data.data.pageSize;
								_this.pageNo = res.data.data.pageNo;
								_this.pageTotal = res.data.data.pageTotal;
								_this.recordList = res.data.data.recordList;

							case 14:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		getCateList: function getCateList() {
			var _this2 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
				var res;
				return _regenerator2.default.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								_context2.next = 2;
								return (0, _api.getCategoryList)();

							case 2:
								res = _context2.sent;

								_this2.categorys = res.data.data.recordList;

							case 4:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this2);
			}))();
		},
		handleInputChanged: function handleInputChanged(val) {
			if (val.trim().length === 0) {
				if (this.addFormVisible) {
					this.addForm.singerId = '';
				} else if (this.editFormVisible) {
					this.editForm.singerId = '';
				}
			}
		},
		searchSinger: function searchSinger(name, callback) {
			var _this3 = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
				var res;
				return _regenerator2.default.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								if (name.trim().length === 0) {
									callback([]);
								}

								_context3.next = 3;
								return (0, _api.getSingerList)({ name: name });

							case 3:
								res = _context3.sent;

								callback(res.data.data.recordList.map(function (item) {
									return (0, _extends3.default)({}, item, { value: item.name });
								}));

							case 5:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, _this3);
			}))();
		},

		handleEdit: function handleEdit(index, row) {
			this.editFormVisible = true;
			this.editForm = (0, _assign2.default)({}, row);
			this.fileList = [{ name: row.fileName, url: row.url }];
		},

		handleAdd: function handleAdd() {
			this.addFormVisible = true;
			this.addForm = {
				name: '',
				categoryId: '',
				url: '',
				hash: '',
				fileSize: '',
				singerId: '',
				singerName: ''
			};
			this.fileList = [];
		},

		editSubmit: function editSubmit() {
			var _this4 = this;

			this.$refs.editForm.validate(function () {
				var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(valid) {
					var para, res;
					return _regenerator2.default.wrap(function _callee4$(_context4) {
						while (1) {
							switch (_context4.prev = _context4.next) {
								case 0:
									if (!valid) {
										_context4.next = 14;
										break;
									}

									_this4.editLoading = true;
									para = (0, _assign2.default)({}, _this4.editForm);
									_context4.next = 5;
									return (0, _api.editMusic)(para);

								case 5:
									res = _context4.sent;

									_this4.editLoading = false;

									if (!(res.data.status !== 200)) {
										_context4.next = 10;
										break;
									}

									_this4.$message({
										message: res.data.message,
										type: 'warning'
									});
									return _context4.abrupt('return');

								case 10:
									_this4.$message({
										message: '提交成功',
										type: 'success'
									});
									_this4.$refs['editForm'].resetFields();
									_this4.editFormVisible = false;
									_this4.fetch();

								case 14:
								case 'end':
									return _context4.stop();
							}
						}
					}, _callee4, _this4);
				}));

				return function (_x) {
					return _ref.apply(this, arguments);
				};
			}());
		},

		addSubmit: function addSubmit() {
			var _this5 = this;

			this.$refs.addForm.validate(function () {
				var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(valid) {
					var para, res;
					return _regenerator2.default.wrap(function _callee5$(_context5) {
						while (1) {
							switch (_context5.prev = _context5.next) {
								case 0:
									if (!valid) {
										_context5.next = 14;
										break;
									}

									_this5.addLoading = true;
									para = (0, _assign2.default)({}, _this5.addForm);
									_context5.next = 5;
									return (0, _api.addMusic)(para);

								case 5:
									res = _context5.sent;

									_this5.addLoading = false;

									if (!(res.data.status !== 200)) {
										_context5.next = 10;
										break;
									}

									_this5.$message({
										message: res.data.message,
										type: 'warning'
									});
									return _context5.abrupt('return');

								case 10:
									_this5.$message({
										message: '提交成功',
										type: 'success'
									});
									_this5.$refs['addForm'].resetFields();
									_this5.addFormVisible = false;
									_this5.fetch();

								case 14:
								case 'end':
									return _context5.stop();
							}
						}
					}, _callee5, _this5);
				}));

				return function (_x2) {
					return _ref2.apply(this, arguments);
				};
			}());
		},
		handleUploadSuccess: function handleUploadSuccess(res, file) {
			if (this.addFormVisible) {
				this.addForm.url = res.data.url;
				this.addForm.fileName = file.name;
				this.addForm.hash = res.data.fields.hash;
				this.addForm.fileSize = res.data.fields.fileSize;
			} else if (this.editFormVisible) {
				this.editForm.url = res.data.url;
				this.editForm.fileName = file.name;
				this.editForm.hash = res.data.fields.hash;
				this.editForm.fileSize = res.data.fields.fileSize;
			}
		},
		handleUploadError: function handleUploadError(error) {
			console.log(error);
		},
		handleSelect: function handleSelect(item) {
			if (this.addFormVisible) {
				this.addForm.singerId = item._id;
				this.addForm.singerName = item.name;
			} else if (this.editFormVisible) {
				this.editForm.singerId = item._id;
				this.editForm.singerName = item.name;
			}
		},

		handleDel: function handleDel(index, row) {
			var _this6 = this;

			this.$confirm('确认删除该记录吗?', '提示', {
				type: 'warning'
			}).then((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
				var para, res;
				return _regenerator2.default.wrap(function _callee6$(_context6) {
					while (1) {
						switch (_context6.prev = _context6.next) {
							case 0:
								_this6.listLoading = true;
								para = { id: row._id };
								_context6.next = 4;
								return (0, _api.removeMusic)(para);

							case 4:
								res = _context6.sent;

								_this6.listLoading = false;

								if (!(res.data.status !== 200)) {
									_context6.next = 9;
									break;
								}

								_this6.$message({
									message: res.data.message,
									type: 'warning'
								});
								return _context6.abrupt('return');

							case 9:
								_this6.$message({
									message: '删除成功',
									type: 'success'
								});
								_this6.fetch();

							case 11:
							case 'end':
								return _context6.stop();
						}
					}
				}, _callee6, _this6);
			}))).catch(function () {});
		},
		selsChange: function selsChange(sels) {
			this.sels = sels;
		},

		batchRemove: function batchRemove() {
			var _this7 = this;

			var ids = this.sels.map(function (item) {
				return item._id;
			}).toString();
			this.$confirm('确认删除选中记录吗？', '提示', {
				type: 'warning'
			}).then((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7() {
				var para, res;
				return _regenerator2.default.wrap(function _callee7$(_context7) {
					while (1) {
						switch (_context7.prev = _context7.next) {
							case 0:
								_this7.listLoading = true;
								para = { ids: ids };
								_context7.next = 4;
								return (0, _api.batchRemoveMusic)(para);

							case 4:
								res = _context7.sent;

								_this7.listLoading = false;

								if (!(res.data.status !== 200)) {
									_context7.next = 9;
									break;
								}

								_this7.$message({
									message: res.data.message,
									type: 'warning'
								});
								return _context7.abrupt('return');

							case 9:
								_this7.$message({
									message: '删除成功',
									type: 'success'
								});
								_this7.fetch();

							case 11:
							case 'end':
								return _context7.stop();
						}
					}
				}, _callee7, _this7);
			}))).catch(function () {});
		},
		handelAddSingerName: function () {
			var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8() {
				var para, res;
				return _regenerator2.default.wrap(function _callee8$(_context8) {
					while (1) {
						switch (_context8.prev = _context8.next) {
							case 0:
								this.addSingerLoading = true;
								para = { name: this.editFormVisible ? this.editForm.singerName : this.addForm.singerName };
								_context8.next = 4;
								return (0, _api.addSinger)(para);

							case 4:
								res = _context8.sent;

								this.addSingerLoading = false;

								if (!(res.data.status !== 200)) {
									_context8.next = 9;
									break;
								}

								this.$message({
									message: res.data.message,
									type: 'warning'
								});
								return _context8.abrupt('return');

							case 9:
								this.$message({
									message: '添加成功',
									type: 'success'
								});
								if (this.editFormVisible) {
									this.editForm.singerId = res.data.data._id;
								} else {
									this.addForm.singerId = res.data.data._id;
								}

							case 11:
							case 'end':
								return _context8.stop();
						}
					}
				}, _callee8, this);
			}));

			function handelAddSingerName() {
				return _ref5.apply(this, arguments);
			}

			return handelAddSingerName;
		}()
	},
	mounted: function mounted() {
		var _this8 = this;

		return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9() {
			return _regenerator2.default.wrap(function _callee9$(_context9) {
				while (1) {
					switch (_context9.prev = _context9.next) {
						case 0:
							_context9.next = 2;
							return _this8.getCateList();

						case 2:
							_this8.fetch();

						case 3:
						case 'end':
							return _context9.stop();
					}
				}
			}, _callee9, _this8);
		}))();
	}
};

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = __webpack_require__(37);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(36);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _api = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			form: {
				oldPass: '',
				newPass: '',
				confirmPass: ''
			},
			loading: false
		};
	},

	methods: {
		onSubmit: function onSubmit() {
			var _this = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var res;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								if (!(!_this.form.oldPass || _this.form.oldPass.trim().length < 6)) {
									_context.next = 3;
									break;
								}

								_this.$message({
									message: '旧密码必须至少6位',
									type: 'warning'
								});
								return _context.abrupt('return');

							case 3:
								if (!(!_this.form.newPass || _this.form.newPass.trim().length < 6)) {
									_context.next = 6;
									break;
								}

								_this.$message({
									message: '新密码必须至少6位',
									type: 'warning'
								});
								return _context.abrupt('return');

							case 6:
								if (!(_this.form.newPass !== _this.form.confirmPass)) {
									_context.next = 9;
									break;
								}

								_this.$message({
									message: '两次密码必须相等',
									type: 'warning'
								});
								return _context.abrupt('return');

							case 9:
								_this.loading = true;
								_context.next = 12;
								return (0, _api.changePw)(_this.form);

							case 12:
								res = _context.sent;

								_this.loading = false;

								if (!(res.data.status !== 200)) {
									_context.next = 17;
									break;
								}

								_this.$message({
									message: res.data.message,
									type: 'success'
								});
								return _context.abrupt('return');

							case 17:
								_this.$message({
									message: '更新成功',
									type: 'success'
								});
								_this.$router.replace('/login');

							case 19:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		cancel: function cancel() {
			this.$router.back();
		}
	}
};

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__(40);

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = __webpack_require__(37);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(36);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _util = __webpack_require__(47);

var _util2 = _interopRequireDefault(_util);

var _api = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			filters: {
				name: ''
			},
			recordList: [],
			pageTotal: 0,
			currentPage: 1,
			pageSize: 15,
			pageNo: 1,
			listLoading: false,
			sels: [],

			editFormVisible: false,
			editLoading: false,
			editFormRules: {
				name: [{ required: true, message: '请输入歌手名', trigger: 'blur' }]
			},

			editForm: {
				id: 0,
				name: ''
			},

			addFormVisible: false,
			addLoading: false,
			addFormRules: {
				name: [{ required: true, message: '请输入歌手名', trigger: 'blur' }]
			},

			addForm: {
				name: ''
			}

		};
	},

	methods: {
		handleCurrentChange: function handleCurrentChange(val) {
			this.currentPage = val;
			this.fetch();
		},
		fetch: function fetch() {
			var _this = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var para, res;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								para = {
									name: _this.filters.name,
									currentPage: _this.currentPage,
									pageSize: _this.pageSize
								};

								_this.listLoading = true;
								_context.next = 4;
								return (0, _api.getSingerListPage)(para);

							case 4:
								res = _context.sent;

								_this.currentPage = res.data.data.currentPage;
								_this.pageSize = res.data.data.pageSize;
								_this.pageNo = res.data.data.pageNo;
								_this.pageTotal = res.data.data.pageTotal;
								_this.recordList = res.data.data.recordList;
								_this.listLoading = false;

							case 11:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},

		handleEdit: function handleEdit(index, row) {
			this.editFormVisible = true;
			this.editForm = (0, _assign2.default)({}, row);
		},

		handleAdd: function handleAdd() {
			this.addFormVisible = true;
			this.addForm = {
				name: ''
			};
		},

		editSubmit: function editSubmit() {
			var _this2 = this;

			this.$refs.editForm.validate(function () {
				var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(valid) {
					var para, res;
					return _regenerator2.default.wrap(function _callee2$(_context2) {
						while (1) {
							switch (_context2.prev = _context2.next) {
								case 0:
									if (!valid) {
										_context2.next = 14;
										break;
									}

									_this2.editLoading = true;
									para = (0, _assign2.default)({}, _this2.editForm);
									_context2.next = 5;
									return (0, _api.editSinger)(para);

								case 5:
									res = _context2.sent;

									_this2.editLoading = false;

									if (!(res.data.status !== 200)) {
										_context2.next = 10;
										break;
									}

									_this2.$message({
										message: res.data.message,
										type: 'warning'
									});
									return _context2.abrupt('return');

								case 10:
									_this2.$message({
										message: '提交成功',
										type: 'success'
									});
									_this2.$refs['editForm'].resetFields();
									_this2.editFormVisible = false;
									_this2.fetch();

								case 14:
								case 'end':
									return _context2.stop();
							}
						}
					}, _callee2, _this2);
				}));

				return function (_x) {
					return _ref.apply(this, arguments);
				};
			}());
		},

		addSubmit: function addSubmit() {
			var _this3 = this;

			this.$refs.addForm.validate(function () {
				var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(valid) {
					var para, res;
					return _regenerator2.default.wrap(function _callee3$(_context3) {
						while (1) {
							switch (_context3.prev = _context3.next) {
								case 0:
									if (!valid) {
										_context3.next = 14;
										break;
									}

									_this3.addLoading = true;
									para = (0, _assign2.default)({}, _this3.addForm);
									_context3.next = 5;
									return (0, _api.addSinger)(para);

								case 5:
									res = _context3.sent;

									_this3.addLoading = false;

									if (!(res.data.status !== 200)) {
										_context3.next = 10;
										break;
									}

									_this3.$message({
										message: res.data.message,
										type: 'warning'
									});
									return _context3.abrupt('return');

								case 10:
									_this3.$message({
										message: '提交成功',
										type: 'success'
									});
									_this3.$refs['addForm'].resetFields();
									_this3.addFormVisible = false;
									_this3.fetch();

								case 14:
								case 'end':
									return _context3.stop();
							}
						}
					}, _callee3, _this3);
				}));

				return function (_x2) {
					return _ref2.apply(this, arguments);
				};
			}());
		},

		handleDel: function handleDel(index, row) {
			var _this4 = this;

			this.$confirm('确认删除该记录吗?', '提示', {
				type: 'warning'
			}).then((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
				var para, res;
				return _regenerator2.default.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								_this4.listLoading = true;
								para = { id: row._id };
								_context4.next = 4;
								return (0, _api.removeSinger)(para);

							case 4:
								res = _context4.sent;

								_this4.listLoading = false;

								if (!(res.data.status !== 200)) {
									_context4.next = 9;
									break;
								}

								_this4.$message({
									message: res.data.message,
									type: 'warning'
								});
								return _context4.abrupt('return');

							case 9:
								_this4.$message({
									message: '删除成功',
									type: 'success'
								});
								_this4.fetch();

							case 11:
							case 'end':
								return _context4.stop();
						}
					}
				}, _callee4, _this4);
			}))).catch(function () {});
		},
		selsChange: function selsChange(sels) {
			this.sels = sels;
		},

		batchRemove: function batchRemove() {
			var _this5 = this;

			var ids = this.sels.map(function (item) {
				return item._id;
			}).toString();
			this.$confirm('确认删除选中记录吗？', '提示', {
				type: 'warning'
			}).then((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
				var para, res;
				return _regenerator2.default.wrap(function _callee5$(_context5) {
					while (1) {
						switch (_context5.prev = _context5.next) {
							case 0:
								_this5.listLoading = true;
								para = { ids: ids };
								_context5.next = 4;
								return (0, _api.batchRemoveSinger)(para);

							case 4:
								res = _context5.sent;

								_this5.listLoading = false;

								if (!(res.data.status !== 200)) {
									_context5.next = 9;
									break;
								}

								_this5.$message({
									message: res.data.message,
									type: 'warning'
								});
								return _context5.abrupt('return');

							case 9:
								_this5.$message({
									message: '删除成功',
									type: 'success'
								});
								_this5.fetch();

							case 11:
							case 'end':
								return _context5.stop();
						}
					}
				}, _callee5, _this5);
			}))).catch(function () {});
		}
	},
	mounted: function mounted() {
		this.fetch();
	}
};

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__(40);

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = __webpack_require__(37);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(36);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _util = __webpack_require__(47);

var _util2 = _interopRequireDefault(_util);

var _api = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			filters: {
				name: ''
			},
			recordList: [],
			pageTotal: 0,
			currentPage: 1,
			pageSize: 15,
			pageNo: 1,
			listLoading: false,
			sels: [],

			editFormVisible: false,
			editLoading: false,
			editFormRules: {
				name: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
				mobile: [{ required: true, message: '请输入手机号', trigger: 'blur' }]
			},

			editForm: {
				id: 0,
				name: '',
				mobile: ''
			},

			addFormVisible: false,
			addLoading: false,
			addFormRules: {
				name: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
				mobile: [{ required: true, message: '请输入手机号', trigger: 'blur' }]
			},

			addForm: {
				name: '',
				mobile: ''
			}

		};
	},

	methods: {
		handleCurrentChange: function handleCurrentChange(val) {
			this.currentPage = val;
			this.fetch();
		},
		gotoAlbum: function gotoAlbum(user) {
			this.$router.push({
				path: '/album',
				query: {
					userId: user._id,
					username: user.name
				}
			});
		},

		statusStr: function statusStr(row, column) {
			return !row.code && row.uuid ? '已绑定' : '********';
		},

		maskMobile: function maskMobile(row, column) {
			if (row.mobile && row.mobile.length >= 11) {
				var ret = row.mobile.split('');
				ret.splice(3, 4, '****');
				return ret.join('');
			}
			return row.mobile;
		},

		maskUUID: function maskUUID(row, column) {
			if (row.uuid && row.uuid.length >= 32) {
				var ret = row.uuid.split('');
				ret.splice(8, 16, '****************');
				return ret.join('');
			}
			return row.uuid;
		},
		fetch: function fetch() {
			var _this = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var para, res;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								para = {
									name: _this.filters.name,
									currentPage: _this.currentPage,
									pageSize: _this.pageSize
								};

								_this.listLoading = true;
								_context.next = 4;
								return (0, _api.getUserListPage)(para);

							case 4:
								res = _context.sent;

								_this.listLoading = false;

								if (!(res.data.status !== 200)) {
									_context.next = 9;
									break;
								}

								_this.$message({
									message: res.data.message,
									type: 'warning'
								});
								return _context.abrupt('return');

							case 9:
								_this.currentPage = res.data.data.currentPage;
								_this.pageSize = res.data.data.pageSize;
								_this.pageNo = res.data.data.pageNo;
								_this.pageTotal = res.data.data.pageTotal;
								_this.recordList = res.data.data.recordList;

							case 14:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},

		handleEdit: function handleEdit(index, row) {
			this.editFormVisible = true;
			this.editForm = (0, _assign2.default)({}, row);
		},

		handleAdd: function handleAdd() {
			this.addFormVisible = true;
			this.addForm = {
				name: '',
				mobile: ''
			};
		},

		editSubmit: function editSubmit() {
			var _this2 = this;

			this.$refs.editForm.validate(function () {
				var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(valid) {
					var para, res;
					return _regenerator2.default.wrap(function _callee2$(_context2) {
						while (1) {
							switch (_context2.prev = _context2.next) {
								case 0:
									if (!valid) {
										_context2.next = 14;
										break;
									}

									_this2.editLoading = true;
									para = (0, _assign2.default)({}, _this2.editForm);
									_context2.next = 5;
									return (0, _api.editUser)(para);

								case 5:
									res = _context2.sent;

									_this2.editLoading = false;

									if (!(res.data.status !== 200)) {
										_context2.next = 10;
										break;
									}

									_this2.$message({
										message: res.data.message,
										type: 'warning'
									});
									return _context2.abrupt('return');

								case 10:
									_this2.$message({
										message: '提交成功',
										type: 'success'
									});
									_this2.$refs['editForm'].resetFields();
									_this2.editFormVisible = false;
									_this2.fetch();

								case 14:
								case 'end':
									return _context2.stop();
							}
						}
					}, _callee2, _this2);
				}));

				return function (_x) {
					return _ref.apply(this, arguments);
				};
			}());
		},

		addSubmit: function addSubmit() {
			var _this3 = this;

			this.$refs.addForm.validate(function () {
				var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(valid) {
					var para, res;
					return _regenerator2.default.wrap(function _callee3$(_context3) {
						while (1) {
							switch (_context3.prev = _context3.next) {
								case 0:
									if (!valid) {
										_context3.next = 14;
										break;
									}

									_this3.addLoading = true;
									para = (0, _assign2.default)({}, _this3.addForm);
									_context3.next = 5;
									return (0, _api.addUser)(para);

								case 5:
									res = _context3.sent;

									_this3.addLoading = false;

									if (!(res.data.status !== 200)) {
										_context3.next = 10;
										break;
									}

									_this3.$message({
										message: res.data.message,
										type: 'warning'
									});
									return _context3.abrupt('return');

								case 10:
									_this3.$message({
										message: '提交成功',
										type: 'success'
									});
									_this3.$refs['addForm'].resetFields();
									_this3.addFormVisible = false;
									_this3.fetch();

								case 14:
								case 'end':
									return _context3.stop();
							}
						}
					}, _callee3, _this3);
				}));

				return function (_x2) {
					return _ref2.apply(this, arguments);
				};
			}());
		},

		handleDel: function handleDel(index, row) {
			var _this4 = this;

			this.$confirm('确认删除该记录吗?', '提示', {
				type: 'warning'
			}).then((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
				var para, res;
				return _regenerator2.default.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								_this4.listLoading = true;
								para = { id: row._id };
								_context4.next = 4;
								return (0, _api.removeUser)(para);

							case 4:
								res = _context4.sent;

								_this4.listLoading = false;

								if (!(res.data.status !== 200)) {
									_context4.next = 9;
									break;
								}

								_this4.$message({
									message: res.data.message,
									type: 'warning'
								});
								return _context4.abrupt('return');

							case 9:
								_this4.$message({
									message: '删除成功',
									type: 'success'
								});
								_this4.fetch();

							case 11:
							case 'end':
								return _context4.stop();
						}
					}
				}, _callee4, _this4);
			}))).catch(function () {});
		},
		selsChange: function selsChange(sels) {
			this.sels = sels;
		},

		batchRemove: function batchRemove() {
			var _this5 = this;

			var ids = this.sels.map(function (item) {
				return item._id;
			}).toString();
			this.$confirm('确认删除选中记录吗？', '提示', {
				type: 'warning'
			}).then((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
				var para, res;
				return _regenerator2.default.wrap(function _callee5$(_context5) {
					while (1) {
						switch (_context5.prev = _context5.next) {
							case 0:
								_this5.listLoading = true;
								para = { ids: ids };
								_context5.next = 4;
								return (0, _api.batchRemoveUser)(para);

							case 4:
								res = _context5.sent;

								_this5.listLoading = false;

								if (!(res.data.status !== 200)) {
									_context5.next = 9;
									break;
								}

								_this5.$message({
									message: res.data.message,
									type: 'warning'
								});
								return _context5.abrupt('return');

							case 9:
								_this5.$message({
									message: '删除成功',
									type: 'success'
								});
								_this5.fetch();

							case 11:
							case 'end':
								return _context5.stop();
						}
					}
				}, _callee5, _this5);
			}))).catch(function () {});
		}
	},
	mounted: function mounted() {
		this.fetch();
	}
};

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__(40);

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = __webpack_require__(37);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(36);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _util = __webpack_require__(47);

var _util2 = _interopRequireDefault(_util);

var _api = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		var token = sessionStorage.getItem('token');
		return {
			headers: { Authorization: 'Bearer ' + token },
			filters: {
				code: ''
			},
			recordList: [],
			pageTotal: 0,
			currentPage: 1,
			pageSize: 15,
			pageNo: 1,
			listLoading: false,
			sels: [],

			editFormVisible: false,
			editLoading: false,
			editFormRules: {
				code: [{ required: true, message: '请输入版本号', trigger: 'blur' }],
				url: [{ required: true, message: '请上传apk', trigger: 'blur' }]
			},

			editForm: {
				id: 0,
				code: '',
				description: '',
				url: '',
				fileSize: '',
				hash: ''
			},

			addFormVisible: false,
			addLoading: false,
			addFormRules: {
				code: [{ required: true, message: '请输入分类名称', trigger: 'blur' }],
				url: [{ required: true, message: '请上传apk', trigger: 'blur' }]
			},

			addForm: {
				code: '',
				description: '',
				url: '',
				fileSize: '',
				hash: '',
				fileList: []
			},
			uploadUrl: _api.uploadUrl
		};
	},

	methods: {
		handleCurrentChange: function handleCurrentChange(val) {
			this.currentPage = val;
			this.fetch();
		},
		fetch: function fetch() {
			var _this = this;

			return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
				var para, res;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								para = {
									code: _this.filters.code,
									currentPage: _this.currentPage,
									pageSize: _this.pageSize
								};

								_this.listLoading = true;
								_context.next = 4;
								return (0, _api.getVersionListPage)(para);

							case 4:
								res = _context.sent;

								_this.listLoading = false;

								if (!(res.data.status !== 200)) {
									_context.next = 9;
									break;
								}

								_this.$message({
									message: res.data.message,
									type: 'warning'
								});
								return _context.abrupt('return');

							case 9:
								_this.currentPage = res.data.data.currentPage;
								_this.pageSize = res.data.data.pageSize;
								_this.pageNo = res.data.data.pageNo;
								_this.pageTotal = res.data.data.pageTotal;
								_this.recordList = res.data.data.recordList;

							case 14:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},

		handleEdit: function handleEdit(index, row) {
			this.editFormVisible = true;
			this.editForm = (0, _assign2.default)({}, row);
		},

		handleAdd: function handleAdd() {
			this.addFormVisible = true;
			this.addForm = {
				code: '',
				url: '',
				description: '',
				fileSize: '',
				hash: '',
				fileList: []
			};
		},

		editSubmit: function editSubmit() {
			var _this2 = this;

			this.$refs.editForm.validate(function () {
				var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(valid) {
					var para, _res;

					return _regenerator2.default.wrap(function _callee2$(_context2) {
						while (1) {
							switch (_context2.prev = _context2.next) {
								case 0:
									if (!valid) {
										_context2.next = 14;
										break;
									}

									_this2.editLoading = true;
									para = (0, _assign2.default)({}, _this2.editForm);
									_context2.next = 5;
									return (0, _api.editVersion)(para);

								case 5:
									_res = _context2.sent;

									_this2.editLoading = false;

									if (!(_res.data.status !== 200)) {
										_context2.next = 10;
										break;
									}

									_this2.$message({
										message: _res.data.message,
										type: 'warning'
									});
									return _context2.abrupt('return');

								case 10:
									_this2.$message({
										message: '提交成功',
										type: 'success'
									});
									_this2.$refs['editForm'].resetFields();
									_this2.editFormVisible = false;
									_this2.fetch();

								case 14:
								case 'end':
									return _context2.stop();
							}
						}
					}, _callee2, _this2);
				}));

				return function (_x) {
					return _ref.apply(this, arguments);
				};
			}());
		},

		addSubmit: function addSubmit() {
			var _this3 = this;

			this.$refs.addForm.validate(function () {
				var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(valid) {
					var para, _res2;

					return _regenerator2.default.wrap(function _callee3$(_context3) {
						while (1) {
							switch (_context3.prev = _context3.next) {
								case 0:
									if (!valid) {
										_context3.next = 14;
										break;
									}

									_this3.addLoading = true;
									para = (0, _assign2.default)({}, _this3.addForm);
									_context3.next = 5;
									return (0, _api.addVersion)(para);

								case 5:
									_res2 = _context3.sent;

									_this3.addLoading = false;

									if (!(_res2.data.status !== 200)) {
										_context3.next = 10;
										break;
									}

									_this3.$message({
										message: _res2.data.message,
										type: 'warning'
									});
									return _context3.abrupt('return');

								case 10:
									_this3.$message({
										message: '提交成功',
										type: 'success'
									});
									_this3.$refs['addForm'].resetFields();
									_this3.addFormVisible = false;
									_this3.fetch();

								case 14:
								case 'end':
									return _context3.stop();
							}
						}
					}, _callee3, _this3);
				}));

				return function (_x2) {
					return _ref2.apply(this, arguments);
				};
			}());
		},
		handleUploadSuccess: function handleUploadSuccess(res, file) {
			this.addForm.url = res.data.url;
			this.addForm.fileSize = res.data.fields.fileSize;
			this.addForm.hash = res.data.fields.hash;
		},
		handleUploadError: function handleUploadError(error) {
			if (res.data.status !== 200) {
				this.$message({
					message: '上传失败',
					type: 'warning'
				});
				return;
			}
			console.log(error);
		},

		handleDel: function handleDel(index, row) {
			var _this4 = this;

			this.$confirm('确认删除该记录吗?', '提示', {
				type: 'warning'
			}).then((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
				var para, res;
				return _regenerator2.default.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								_this4.listLoading = true;
								para = { id: row._id };
								_context4.next = 4;
								return (0, _api.removeVersion)(para);

							case 4:
								res = _context4.sent;

								_this4.listLoading = false;

								if (!(res.data.status !== 200)) {
									_context4.next = 9;
									break;
								}

								_this4.$message({
									message: res.data.message,
									type: 'warning'
								});
								return _context4.abrupt('return');

							case 9:
								_this4.$message({
									message: '删除成功',
									type: 'success'
								});
								_this4.fetch();

							case 11:
							case 'end':
								return _context4.stop();
						}
					}
				}, _callee4, _this4);
			}))).catch(function () {});
		},
		selsChange: function selsChange(sels) {
			this.sels = sels;
		},

		batchRemove: function batchRemove() {
			var _this5 = this;

			var ids = this.sels.map(function (item) {
				return item._id;
			}).toString();
			this.$confirm('确认删除选中记录吗？', '提示', {
				type: 'warning'
			}).then((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
				var para, res;
				return _regenerator2.default.wrap(function _callee5$(_context5) {
					while (1) {
						switch (_context5.prev = _context5.next) {
							case 0:
								_this5.listLoading = true;
								para = { ids: ids };
								_context5.next = 4;
								return (0, _api.batchRemoveVersion)(para);

							case 4:
								res = _context5.sent;

								_this5.listLoading = false;

								if (!(res.data.status !== 200)) {
									_context5.next = 9;
									break;
								}

								_this5.$message({
									message: res.data.message,
									type: 'warning'
								});
								return _context5.abrupt('return');

							case 9:
								_this5.$message({
									message: '删除成功',
									type: 'success'
								});
								_this5.fetch();

							case 11:
							case 'end':
								return _context5.stop();
						}
					}
				}, _callee5, _this5);
			}))).catch(function () {});
		}
	},
	mounted: function mounted() {
		this.fetch();
	}
};

/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _babelPolyfill = __webpack_require__(225);

var _babelPolyfill2 = _interopRequireDefault(_babelPolyfill);

var _vue = __webpack_require__(19);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(230);

var _App2 = _interopRequireDefault(_App);

var _elementUi = __webpack_require__(226);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(227);

__webpack_require__(229);

var _vueRouter = __webpack_require__(231);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _store = __webpack_require__(224);

var _store2 = _interopRequireDefault(_store);

var _vuex = __webpack_require__(150);

var _vuex2 = _interopRequireDefault(_vuex);

var _routes = __webpack_require__(223);

var _routes2 = _interopRequireDefault(_routes);

__webpack_require__(228);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_elementUi2.default);
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vuex2.default);

var router = new _vueRouter2.default({
  routes: _routes2.default
});

router.beforeEach(function (to, from, next) {
  if (to.path == '/login') {
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('token');
  }
  var token = sessionStorage.getItem('token');
  if (!token && to.path != '/login') {
    next({ path: '/login' });
  } else {
    next();
  }
});

new _vue2.default({
  router: router,
  store: _store2.default,

  render: function render(h) {
    return h(_App2.default);
  }
}).$mount('#app');

/***/ }),

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var increment = exports.increment = function increment(_ref) {
    var commit = _ref.commit;

    commit('INCREMENT');
};
var decrement = exports.decrement = function decrement(_ref2) {
    var commit = _ref2.commit;

    commit('DECREMENT');
};

/***/ }),

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getCount = exports.getCount = function getCount(state) {
    return state.count;
};

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.batchRemoveVersion = exports.removeVersion = exports.editVersion = exports.addVersion = exports.getVersionListPage = exports.batchRemoveAlbumMusic = exports.removeAlbumMusic = exports.editAlbumMusic = exports.addAlbumMusic = exports.getAlbumMusicListPage = exports.batchRemoveAlbum = exports.removeAlbum = exports.editAlbum = exports.addAlbum = exports.getAlbumListPage = exports.batchRemoveMusic = exports.removeMusic = exports.editMusic = exports.addMusic = exports.getMusicListPage = exports.getMusicList = exports.batchRemoveSinger = exports.removeSinger = exports.editSinger = exports.addSinger = exports.getSingerListPage = exports.getSingerList = exports.batchRemoveCategory = exports.removeCategory = exports.editCategory = exports.addCategory = exports.getCategoryListPage = exports.getCategoryList = exports.changePw = exports.batchRemoveUser = exports.removeUser = exports.editUser = exports.addUser = exports.getUserListPage = exports.getUserList = exports.getUserInfo = exports.requestLogin = exports.uploadUrl = undefined;

var _promise = __webpack_require__(160);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(254);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_axios2.default.interceptors.request.use(function (config) {
  if (config.showLoading) {
    showFullScreenLoading();
  }
  var token = sessionStorage.getItem('token');
  if (token) {
    config.headers.common['Authorization'] = 'Bearer ' + token;
  }
  return config;
}, function (error) {
  return _promise2.default.reject(error);
});

_axios2.default.interceptors.response.use(function (response) {
  if (response.data.Type == 403) {
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('token');

    setTimeout(function () {
      location.href = '/login';
    }, 3000);
  } else if (response.data.Type == 500 || response.data.Type == 203) {}
  return response;
}, function (error) {
  return _promise2.default.reject(error);
});

var base =  true ? 'https://music.tiaopic.com/api' : 'http://127.0.0.1:7001/api';

var uploadUrl = exports.uploadUrl = base + '/public/upload';

var requestLogin = exports.requestLogin = function requestLogin(params) {
  return _axios2.default.post(base + '/user/login', params).then(function (res) {
    return res.data;
  });
};

var getUserInfo = exports.getUserInfo = function getUserInfo(params) {
  return _axios2.default.get(base + '/user/info', { params: params });
};

var getUserList = exports.getUserList = function getUserList(params) {
  return _axios2.default.get(base + '/user/list', { params: params });
};

var getUserListPage = exports.getUserListPage = function getUserListPage(params) {
  return _axios2.default.get(base + '/user/listpage', { params: params });
};

var addUser = exports.addUser = function addUser(params) {
  return _axios2.default.post(base + '/user/add', params);
};

var editUser = exports.editUser = function editUser(params) {
  return _axios2.default.post(base + '/user/edit', params);
};

var removeUser = exports.removeUser = function removeUser(params) {
  return _axios2.default.post(base + '/user/remove', params);
};

var batchRemoveUser = exports.batchRemoveUser = function batchRemoveUser(params) {
  return _axios2.default.post(base + '/user/batchremove', params);
};

var changePw = exports.changePw = function changePw(params) {
  return _axios2.default.post(base + '/user/changepw', params);
};

var getCategoryList = exports.getCategoryList = function getCategoryList(params) {
  return _axios2.default.get(base + '/category/list', { params: params });
};

var getCategoryListPage = exports.getCategoryListPage = function getCategoryListPage(params) {
  return _axios2.default.get(base + '/category/listpage', { params: params });
};

var addCategory = exports.addCategory = function addCategory(params) {
  return _axios2.default.post(base + '/category/add', params);
};

var editCategory = exports.editCategory = function editCategory(params) {
  return _axios2.default.post(base + '/category/edit', params);
};

var removeCategory = exports.removeCategory = function removeCategory(params) {
  return _axios2.default.post(base + '/category/remove', params);
};

var batchRemoveCategory = exports.batchRemoveCategory = function batchRemoveCategory(params) {
  return _axios2.default.post(base + '/category/batchremove', params);
};

var getSingerList = exports.getSingerList = function getSingerList(params) {
  return _axios2.default.get(base + '/singer/list', { params: params });
};

var getSingerListPage = exports.getSingerListPage = function getSingerListPage(params) {
  return _axios2.default.get(base + '/singer/listpage', { params: params });
};

var addSinger = exports.addSinger = function addSinger(params) {
  return _axios2.default.post(base + '/singer/add', params);
};

var editSinger = exports.editSinger = function editSinger(params) {
  return _axios2.default.post(base + '/singer/edit', params);
};

var removeSinger = exports.removeSinger = function removeSinger(params) {
  return _axios2.default.post(base + '/singer/remove', params);
};

var batchRemoveSinger = exports.batchRemoveSinger = function batchRemoveSinger(params) {
  return _axios2.default.post(base + '/singer/batchremove', params);
};

var getMusicList = exports.getMusicList = function getMusicList(params) {
  return _axios2.default.get(base + '/music/list', { params: params });
};

var getMusicListPage = exports.getMusicListPage = function getMusicListPage(params) {
  return _axios2.default.get(base + '/music/listpage', { params: params });
};

var addMusic = exports.addMusic = function addMusic(params) {
  return _axios2.default.post(base + '/music/add', params);
};

var editMusic = exports.editMusic = function editMusic(params) {
  return _axios2.default.post(base + '/music/edit', params);
};

var removeMusic = exports.removeMusic = function removeMusic(params) {
  return _axios2.default.post(base + '/music/remove', params);
};

var batchRemoveMusic = exports.batchRemoveMusic = function batchRemoveMusic(params) {
  return _axios2.default.post(base + '/music/batchremove', params);
};

var getAlbumListPage = exports.getAlbumListPage = function getAlbumListPage(params) {
  return _axios2.default.get(base + '/album/listpage', { params: params });
};

var addAlbum = exports.addAlbum = function addAlbum(params) {
  return _axios2.default.post(base + '/album/add', params);
};

var editAlbum = exports.editAlbum = function editAlbum(params) {
  return _axios2.default.post(base + '/album/edit', params);
};

var removeAlbum = exports.removeAlbum = function removeAlbum(params) {
  return _axios2.default.post(base + '/album/remove', params);
};

var batchRemoveAlbum = exports.batchRemoveAlbum = function batchRemoveAlbum(params) {
  return _axios2.default.post(base + '/album/batchremove', params);
};

var getAlbumMusicListPage = exports.getAlbumMusicListPage = function getAlbumMusicListPage(params) {
  return _axios2.default.get(base + '/albumMusic/listpage', { params: params });
};

var addAlbumMusic = exports.addAlbumMusic = function addAlbumMusic(params) {
  return _axios2.default.post(base + '/albumMusic/add', params);
};

var editAlbumMusic = exports.editAlbumMusic = function editAlbumMusic(params) {
  return _axios2.default.post(base + '/albumMusic/edit', params);
};

var removeAlbumMusic = exports.removeAlbumMusic = function removeAlbumMusic(params) {
  return _axios2.default.post(base + '/albumMusic/remove', params);
};

var batchRemoveAlbumMusic = exports.batchRemoveAlbumMusic = function batchRemoveAlbumMusic(params) {
  return _axios2.default.post(base + '/albumMusic/batchremove', params);
};

var getVersionListPage = exports.getVersionListPage = function getVersionListPage(params) {
  return _axios2.default.get(base + '/version/listpage', { params: params });
};

var addVersion = exports.addVersion = function addVersion(params) {
  return _axios2.default.post(base + '/version/add', params);
};

var editVersion = exports.editVersion = function editVersion(params) {
  return _axios2.default.post(base + '/version/edit', params);
};

var removeVersion = exports.removeVersion = function removeVersion(params) {
  return _axios2.default.post(base + '/version/remove', params);
};

var batchRemoveVersion = exports.batchRemoveVersion = function batchRemoveVersion(params) {
  return _axios2.default.post(base + '/version/batchremove', params);
};

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';
function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) {
        s = '0' + s;
    }
    return s;
};

exports.default = {
    getQueryStringByName: function getQueryStringByName(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        var context = "";
        if (r != null) context = r[2];
        reg = null;
        r = null;
        return context == null || context == "" || context == "undefined" ? "" : context;
    },
    formatDate: {
        format: function format(date, pattern) {
            pattern = pattern || DEFAULT_PATTERN;
            return pattern.replace(SIGN_REGEXP, function ($0) {
                switch ($0.charAt(0)) {
                    case 'y':
                        return padding(date.getFullYear(), $0.length);
                    case 'M':
                        return padding(date.getMonth() + 1, $0.length);
                    case 'd':
                        return padding(date.getDate(), $0.length);
                    case 'w':
                        return date.getDay() + 1;
                    case 'h':
                        return padding(date.getHours(), $0.length);
                    case 'm':
                        return padding(date.getMinutes(), $0.length);
                    case 's':
                        return padding(date.getSeconds(), $0.length);
                }
            });
        },
        parse: function parse(dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP);
            var matchs2 = dateString.match(/(\d)+/g);
            if (matchs1.length == matchs2.length) {
                var _date = new Date(1970, 0, 1);
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i]);
                    var sign = matchs1[i];
                    switch (sign.charAt(0)) {
                        case 'y':
                            _date.setFullYear(_int);break;
                        case 'M':
                            _date.setMonth(_int - 1);break;
                        case 'd':
                            _date.setDate(_int);break;
                        case 'h':
                            _date.setHours(_int);break;
                        case 'm':
                            _date.setMinutes(_int);break;
                        case 's':
                            _date.setSeconds(_int);break;
                    }
                }
                return _date;
            }
            return null;
        }
    },
    formatFileSize: function formatFileSize(value) {
        if (null == value || value == '') {
            return "0 Bytes";
        }
        var unitArr = new Array("Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB");
        var index = 0;
        var srcsize = parseFloat(value);
        index = Math.floor(Math.log(srcsize) / Math.log(1024));
        var size = srcsize / Math.pow(1024, index);
        size = size.toFixed(2);
        return size + unitArr[index];
    }
};

/***/ }),

/***/ 546:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 547:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 548:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 549:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 550:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 551:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 552:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 553:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 554:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 555:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 556:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(546)

var Component = __webpack_require__(24)(
  /* script */
  null,
  /* template */
  __webpack_require__(572),
  /* scopeId */
  "data-v-1c11acb4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(550)

var Component = __webpack_require__(24)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(576),
  /* scopeId */
  "data-v-2afb6dbd",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(549)

var Component = __webpack_require__(24)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(575),
  /* scopeId */
  "data-v-28c4cbd0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 564:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(554)

var Component = __webpack_require__(24)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(580),
  /* scopeId */
  "data-v-6bf5c0a0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(553)

var Component = __webpack_require__(24)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(579),
  /* scopeId */
  "data-v-594e95fe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(555)

var Component = __webpack_require__(24)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(582),
  /* scopeId */
  "data-v-94ba5c92",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 567:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(551)

var Component = __webpack_require__(24)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(577),
  /* scopeId */
  "data-v-335e1273",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 568:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(24)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(581),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(556)

var Component = __webpack_require__(24)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(583),
  /* scopeId */
  "data-v-d686dac4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 570:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(552)

var Component = __webpack_require__(24)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(578),
  /* scopeId */
  "data-v-3f1d5426",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(547)

var Component = __webpack_require__(24)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(573),
  /* scopeId */
  "data-v-1c450bb4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 572:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("404 page not found")])
},staticRenderFns: []}

/***/ }),

/***/ 573:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "版本号"
    },
    model: {
      value: (_vm.filters.code),
      callback: function($$v) {
        _vm.$set(_vm.filters, "code", $$v)
      },
      expression: "filters.code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.fetch
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.recordList,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "code",
      "label": "版本号",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "url",
      "label": "下载地址",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticClass: "buttonText",
          attrs: {
            "href": scope.row.url,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(scope.row.url))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fileSize",
      "label": "文件大小",
      "width": "250"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "description",
      "label": "描述",
      "width": "250"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "创建时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updateTime",
      "label": "更新时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "250",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": this.sels.length === 0
    },
    on: {
      "click": _vm.batchRemove
    }
  }, [_vm._v("批量删除")]), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "current-page": _vm.currentPage,
      "page-count": _vm.pageNo,
      "total": _vm.pageTotal
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "版本号",
      "prop": "code"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.editForm.code))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "描述",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.description),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "description", $$v)
      },
      expression: "editForm.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "下载地址",
      "prop": "url"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.editForm.url))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "文件大小",
      "prop": "fileSize"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.editForm.fileSize))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "MD5",
      "prop": "hash"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.editForm.hash))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "版本号",
      "prop": "code"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.code),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "code", $$v)
      },
      expression: "addForm.code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "描述",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.description),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "description", $$v)
      },
      expression: "addForm.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "apk文件",
      "prop": "url"
    }
  }, [_c('el-upload', {
    attrs: {
      "disabled": _vm.addForm.fileList.length > 0,
      "headers": _vm.headers,
      "auto-upload": true,
      "action": _vm.uploadUrl,
      "accept": "application/vnd.android.package-archive",
      "file-list": _vm.addForm.fileList,
      "on-success": _vm.handleUploadSuccess,
      "on-error": _vm.handleUploadError,
      "limit": 1
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("请上传apk格式文件")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "文件大小",
      "prop": "fileSize"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.addForm.fileSize))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "MD5",
      "prop": "hash"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.addForm.hash))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 574:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 575:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-button', {
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(("返回[" + (this.$route.query.username) + "歌单-" + (this.$route.query.title) + "]")))])], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "歌曲名"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.fetch
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.recordList,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "priority",
      "label": "排序",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "categoryId",
      "label": "分类",
      "width": "100",
      "formatter": _vm.formatCategory
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "singerName",
      "label": "歌手",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fileName",
      "label": "文件",
      "width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticClass: "buttonText",
          attrs: {
            "href": scope.row.url,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(scope.row.fileName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fileSize",
      "label": "大小",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "创建时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updateTime",
      "label": "更新时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "250",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": this.sels.length === 0
    },
    on: {
      "click": _vm.batchRemove
    }
  }, [_vm._v("批量删除")]), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "current-page": _vm.currentPage,
      "page-count": _vm.pageNo,
      "total": _vm.pageTotal
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px",
      "rules": _vm.editFormRules
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editForm.albumId),
      expression: "editForm.albumId"
    }],
    attrs: {
      "hidden": ""
    },
    domProps: {
      "value": (_vm.editForm.albumId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editForm, "albumId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editForm.userId),
      expression: "editForm.userId"
    }],
    attrs: {
      "hidden": ""
    },
    domProps: {
      "value": (_vm.editForm.userId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editForm, "userId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "歌曲名",
      "prop": "name"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.editForm.name))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "歌手",
      "prop": "singerName"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.editForm.singerName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "文件名",
      "prop": "fileName"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.editForm.fileName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "文件大小",
      "prop": "fileSize"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.editForm.fileSize))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "优先级",
      "prop": "priority"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "999",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.priority),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "priority", $$v)
      },
      expression: "editForm.priority"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px",
      "rules": _vm.addFormRules
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addForm.albumId),
      expression: "addForm.albumId"
    }],
    attrs: {
      "hidden": ""
    },
    domProps: {
      "value": (_vm.addForm.albumId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addForm, "albumId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addForm.userId),
      expression: "addForm.userId"
    }],
    attrs: {
      "hidden": ""
    },
    domProps: {
      "value": (_vm.addForm.userId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addForm, "userId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "歌曲名",
      "prop": "name"
    }
  }, [_c('el-autocomplete', {
    staticClass: "el-input",
    attrs: {
      "fetch-suggestions": _vm.searchMusic,
      "placeholder": "搜索歌曲名",
      "trigger-on-focus": false
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "歌手",
      "prop": "singerName"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.addForm.singerName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "文件名",
      "prop": "fileName"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.addForm.fileName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "文件大小",
      "prop": "fileSize"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.addForm.fileSize))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "优先级",
      "prop": "priority"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "999",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.priority),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "priority", $$v)
      },
      expression: "addForm.priority"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 576:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "请选择类型"
    },
    on: {
      "change": _vm.handleSearchTypeChange
    },
    model: {
      value: (_vm.filters.type),
      callback: function($$v) {
        _vm.$set(_vm.filters, "type", $$v)
      },
      expression: "filters.type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "歌单名",
      "value": "name"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "用户ID",
      "value": "userId"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": _vm.placeholder
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.fetch
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.recordList,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticClass: "buttonText",
          attrs: {
            "target": "_blank"
          },
          on: {
            "click": function($event) {
              return _vm.gotoAlbumMusic(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "所有者",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "创建时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updateTime",
      "label": "更新时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "250",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.gotoAlbumMusic(scope.row)
            }
          }
        }, [_vm._v("歌曲列表")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": this.sels.length === 0
    },
    on: {
      "click": _vm.batchRemove
    }
  }, [_vm._v("批量删除")]), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "current-page": _vm.currentPage,
      "page-count": _vm.pageNo,
      "total": _vm.pageTotal
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "歌单名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", $$v)
      },
      expression: "editForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户",
      "prop": "userId"
    }
  }, [_c('el-autocomplete', {
    staticClass: "el-input",
    attrs: {
      "fetch-suggestions": _vm.searchUser,
      "placeholder": "请输入用户名",
      "trigger-on-focus": false
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.editForm.username),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "username", $$v)
      },
      expression: "editForm.username"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "歌单名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户",
      "prop": "userId"
    }
  }, [_c('el-autocomplete', {
    staticClass: "el-input",
    attrs: {
      "fetch-suggestions": _vm.searchUser,
      "placeholder": "请输入用户名",
      "trigger-on-focus": false
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.addForm.username),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "username", $$v)
      },
      expression: "addForm.username"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 577:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "歌曲名"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.fetch
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.recordList,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "categoryId",
      "label": "分类",
      "width": "130",
      "formatter": _vm.formatCategory
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "singerName",
      "label": "歌手",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fileName",
      "label": "文件",
      "width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticClass: "buttonText",
          attrs: {
            "href": scope.row.url,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(scope.row.fileName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fileSize",
      "label": "大小",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "创建时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "250",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": this.sels.length === 0
    },
    on: {
      "click": _vm.batchRemove
    }
  }, [_vm._v("批量删除")]), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "current-page": _vm.currentPage,
      "page-count": _vm.pageNo,
      "total": _vm.pageTotal
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "歌曲ID",
      "prop": "_id"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.editForm._id))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "歌曲名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", $$v)
      },
      expression: "editForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分类",
      "prop": "categoryId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择分类"
    },
    model: {
      value: (_vm.editForm.categoryId),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "categoryId", $$v)
      },
      expression: "editForm.categoryId"
    }
  }, _vm._l((_vm.categorys), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item._id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "歌手",
      "prop": "singerId"
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding-bottom": "0px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-autocomplete', {
    staticClass: "el-input",
    attrs: {
      "fetch-suggestions": _vm.searchSinger,
      "placeholder": "请输入歌手名",
      "trigger-on-focus": false
    },
    on: {
      "select": _vm.handleSelect,
      "input": _vm.handleInputChanged
    },
    model: {
      value: (_vm.editForm.singerName),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "singerName", $$v)
      },
      expression: "editForm.singerName"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    staticClass: "add-button",
    attrs: {
      "disabled": _vm.editForm.singerId !== '' || _vm.editForm.singerName.trim().length == 0,
      "loading": _vm.addSingerLoading
    },
    on: {
      "click": _vm.handelAddSingerName
    }
  }, [_vm._v("\n\t\t\t\t\t\t添加歌手\n\t\t\t\t\t\t")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "mp3文件",
      "prop": "url"
    }
  }, [_c('el-upload', {
    attrs: {
      "disabled": _vm.fileList.length > 0,
      "headers": _vm.headers,
      "auto-upload": true,
      "action": _vm.uploadUrl,
      "accept": "audio/mpeg",
      "file-list": _vm.fileList,
      "on-success": _vm.handleUploadSuccess,
      "on-error": _vm.handleUploadError,
      "limit": 1
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("请上传mp3格式文件")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "文件大小",
      "prop": "fileSize"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.editForm.fileSize))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "MD5",
      "prop": "hasg"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.editForm.hash))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "歌曲名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分类",
      "prop": "categoryId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择分类"
    },
    model: {
      value: (_vm.addForm.categoryId),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "categoryId", $$v)
      },
      expression: "addForm.categoryId"
    }
  }, _vm._l((_vm.categorys), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item._id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "歌手",
      "prop": "singerId"
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding-bottom": "0px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-autocomplete', {
    staticClass: "el-input",
    attrs: {
      "fetch-suggestions": _vm.searchSinger,
      "placeholder": "请输入歌手名",
      "trigger-on-focus": false
    },
    on: {
      "select": _vm.handleSelect,
      "input": _vm.handleInputChanged
    },
    model: {
      value: (_vm.addForm.singerName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "singerName", $$v)
      },
      expression: "addForm.singerName"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    staticClass: "add-button",
    attrs: {
      "disabled": _vm.addForm.singerId !== '' || _vm.addForm.singerName.trim().length == 0,
      "loading": _vm.addSingerLoading
    },
    on: {
      "click": _vm.handelAddSingerName
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t添加歌手\n\t\t\t\t\t\t")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "文件",
      "prop": "url"
    }
  }, [_c('el-upload', {
    attrs: {
      "headers": _vm.headers,
      "auto-upload": true,
      "action": _vm.uploadUrl,
      "accept": "audio/mpeg",
      "file-list": _vm.fileList,
      "on-success": _vm.handleUploadSuccess,
      "on-error": _vm.handleUploadError,
      "limit": 1
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("请上传mp3格式文件")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "文件大小",
      "prop": "fileSize"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.addForm.fileSize))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "MD5",
      "prop": "hasg"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.addForm.hash))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 578:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "用户名"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.fetch
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.recordList,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mobile",
      "label": "手机号",
      "width": "130",
      "formatter": _vm.maskMobile
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "code",
      "label": "邀请码",
      "width": "100",
      "formatter": _vm.statusStr
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "uuid",
      "label": "UUID",
      "width": "320",
      "formatter": _vm.maskUUID
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "创建时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updateTime",
      "label": "登录时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "250",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.gotoAlbum(scope.row)
            }
          }
        }, [_vm._v("查看歌单")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": this.sels.length === 0
    },
    on: {
      "click": _vm.batchRemove
    }
  }, [_vm._v("批量删除")]), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "current-page": _vm.currentPage,
      "page-count": _vm.pageNo,
      "total": _vm.pageTotal
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户ID",
      "prop": "_id"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.editForm._id))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", $$v)
      },
      expression: "editForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "mobile"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "mobile", $$v)
      },
      expression: "editForm.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "code",
      "prop": "code"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.editForm.code))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UUID",
      "prop": "uuid"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.editForm.uuid))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "mobile"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "mobile", $$v)
      },
      expression: "addForm.mobile"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 579:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "logo",
    class: _vm.collapsed ? 'logo-collapse-width' : 'logo-width',
    attrs: {
      "span": 10
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.collapsed ? '' : _vm.sysName) + "\n\t\t")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "tools",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.collapse($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  })])]), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 4
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_vm._v(" " + _vm._s(_vm.sysUserName))]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.changePassword($event)
      }
    }
  }, [_vm._v("更改密码")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout($event)
      }
    }
  }, [_vm._v("退出登录")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('aside', {
    class: _vm.collapsed ? 'menu-collapsed' : 'menu-expanded'
  }, [_c('el-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed),
      expression: "!collapsed"
    }],
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.$route.path,
      "unique-opened": "",
      "router": ""
    },
    on: {
      "open": _vm.handleopen,
      "close": _vm.handleclose,
      "select": _vm.handleselect
    }
  }, [_vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? [(!item.leaf) ? _c('el-submenu', {
      key: index,
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('el-menu-item', {
        key: child.path,
        attrs: {
          "index": child.path
        }
      }, [_vm._v(_vm._s(child.name))]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (item.leaf && item.children.length > 0) ? _c('el-menu-item', {
      key: index,
      attrs: {
        "index": item.children[0].path
      }
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.children[0].name))]) : _vm._e()] : _vm._e()
  })], 2), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collapsed),
      expression: "collapsed"
    }],
    ref: "menuCollapsed",
    staticClass: "el-menu el-menu-vertical-demo collapsed"
  }, _vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? _c('li', {
      key: index,
      staticClass: "el-submenu item"
    }, [(!item.leaf) ? [_c('div', {
      staticClass: "el-submenu__title",
      staticStyle: {
        "padding-left": "20px"
      },
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })]), _vm._v(" "), _c('ul', {
      staticClass: "el-menu submenu",
      class: 'submenu-hook-' + index,
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('li', {
        key: child.path,
        staticClass: "el-menu-item",
        class: _vm.$route.path == child.path ? 'is-active' : '',
        staticStyle: {
          "padding-left": "40px"
        },
        on: {
          "click": function($event) {
            return _vm.$router.push(child.path)
          }
        }
      }, [_vm._v(_vm._s(child.name))]) : _vm._e()
    }), 0)] : [_c('li', {
      staticClass: "el-submenu"
    }, [_c('div', {
      staticClass: "el-submenu__title el-menu-item",
      class: _vm.$route.path == item.children[0].path ? 'is-active' : '',
      staticStyle: {
        "padding-left": "20px",
        "height": "56px",
        "line-height": "56px",
        "padding": "0 20px"
      },
      on: {
        "click": function($event) {
          return _vm.$router.push(item.children[0].path)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })])])]], 2) : _vm._e()
  }), 0)], 1), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "breadcrumb-container",
    attrs: {
      "span": 24
    }
  }, [_c('strong', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$route.name))]), _vm._v(" "), _c('el-breadcrumb', {
    staticClass: "breadcrumb-inner",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.$route.matched), function(item) {
    return _c('el-breadcrumb-item', {
      key: item.path
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t\t\t")])
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 580:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "分类名称"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.fetch
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.recordList,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称",
      "width": "450"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "创建时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updateTime",
      "label": "更新时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "250",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": this.sels.length === 0
    },
    on: {
      "click": _vm.batchRemove
    }
  }, [_vm._v("批量删除")]), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "current-page": _vm.currentPage,
      "page-count": _vm.pageNo,
      "total": _vm.pageTotal
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "分类名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", $$v)
      },
      expression: "editForm.name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "分类名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 581:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "旧密码"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.form.oldPass),
      callback: function($$v) {
        _vm.$set(_vm.form, "oldPass", $$v)
      },
      expression: "form.oldPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "新密码"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.form.newPass),
      callback: function($$v) {
        _vm.$set(_vm.form, "newPass", $$v)
      },
      expression: "form.newPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认密码"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.form.confirmPass),
      callback: function($$v) {
        _vm.$set(_vm.form, "confirmPass", $$v)
      },
      expression: "form.confirmPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_vm._v("更新")]), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel($event)
      }
    }
  }, [_vm._v("取消")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 582:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("系统登录")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "account"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "账号"
    },
    model: {
      value: (_vm.ruleForm2.account),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "account", $$v)
      },
      expression: "ruleForm2.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "密码"
    },
    model: {
      value: (_vm.ruleForm2.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "checkPass", $$v)
      },
      expression: "ruleForm2.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-checkbox', {
    staticClass: "remember",
    attrs: {
      "checked": ""
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("记住密码")]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit2($event)
      }
    }
  }, [_vm._v("登录")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 583:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "歌手名"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.fetch
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.recordList,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称",
      "width": "300"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "创建时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updateTime",
      "label": "更新时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "250",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": this.sels.length === 0
    },
    on: {
      "click": _vm.batchRemove
    }
  }, [_vm._v("批量删除")]), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "current-page": _vm.currentPage,
      "page-count": _vm.pageNo,
      "total": _vm.pageTotal
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "歌手名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", $$v)
      },
      expression: "editForm.name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "歌手名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

},[283]);


// WEBPACK FOOTER //
// static/js/app.549070a9c68058e5c8d2.js